import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class PinPadController extends Controller {
  @service swingBridge;
  @service router;
  @service session;
  @service sidebar;

  queryParams = ['targetPath', 'disableClockIn'];

  get isSidebarOpen() {
    return this.sidebar.isOpen;
  }

  get isEmbeddedInSwing() {
    return this.swingBridge.isEmbeddedInSwing;
  }
}
